/* src/app/location/addressproof/addressproof.component.scss */
.address-container {
  width: 100%;
  margin: 2rem auto;
  text-align: left;
  margin-top: 0px;
}
.address-container h2 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 43px;
  margin-top: 0px;
}
.address-container .upload-section {
  display: flex;
  align-items: center;
  gap: 2rem;
}
.address-container .upload-section .upload-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #fff;
  border: 1px solid #ccc;
  color: black;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
}
.address-container .upload-section .upload-btn i {
  font-size: 1.2rem;
  color: black;
}
.address-container .upload-section .upload-btn:hover {
  background: #fff;
}
.address-container .upload-section .file-status {
  font-size: 1rem;
  color: #000;
  font-weight: bold;
}
.address-container .upload-section .file-status small {
  font-size: 0.8rem;
  color: #333;
  font-weight: normal;
}
::ng-deep .p-inputtext:focus {
  outline: none !important;
  border-color: orange !important;
  background-color: white !important;
}
::ng-deep .p-inputtext:hover {
  outline: none !important;
  border-color: orange !important;
  background-color: white !important;
}
:host ::ng-deep small {
  color: #e24c4c;
  margin-top: 4px !important;
}
/*# sourceMappingURL=addressproof.component-TZVDCRE6.css.map */
